<div class="session-action-button-container m-2">
  <button mat-stroked-button color="primary" (click)="openModal()">
    Démarrer
  </button>
</div>
